import { useEffect, useState } from 'react';

const DateToSelector = ({ onFilterChange, to }) => {
  const [toDate, setToDate] = useState(to);

  useEffect(() => {
    setToDate(to);
  }, [to]);

  return (
    <div className="date-filter">
      <div className="h4Title">Seleccione la fecha hasta la cuál desea consultar</div>
      <div className="date-filter__row">
        <label>Hasta</label>
        <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
        <button type="button" onClick={() => onFilterChange({ toDate })}>
          Consultar
        </button>
      </div>
    </div>
  );
};

export default DateToSelector;
